import React from "react";
import { Link } from "gatsby";
import { fontsName } from "../../assets/fonts/fontsName";
import icon1 from "../../assets/images/services/service-icon1.png";
import shape3 from "../../assets/images/services/service-shape3.png";
import FeatureModal from "./FeatureModal";

const FeatureCard = ({ fact }) => {
  const [openModal, setOpenModal] = React.useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  return (
    <>
      <div className="col-lg-4 col-md-6 col-sm-6" dir="rtl">
        <div className="single-featured-services-item" dir="rtl">
          <div className="icon">
            <img src={icon1} alt="features" />
          </div>
          <h3>
            <Link
              to="/service-details"
              style={{ fontFamily: fontsName.VazirBold }}
            >
              {fact.title}
            </Link>
          </h3>
          <p
            style={{
              width: "300px",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              fontFamily: fontsName.Vazir,
              direction: "rtl",
              textAlign: "right",
            }}
          >
            {fact.description}
          </p>

          <Link
            to="#"
            className="default-btn"
            style={{ fontFamily: fontsName.Vazir }}
            onClick={handleOpenModal}
          >
            <i className="flaticon-right"></i>
            بیشتر بخوانید <span></span>
          </Link>

          <div className="shape">
            <img src={shape3} alt="features" />
          </div>
        </div>
      </div>
      <FeatureModal open={openModal} onClose={handleCloseModal} fact={fact} />
    </>
  );
};

export default FeatureCard;
